import { APIResponseModel } from "../model/APIResponseModel";

export const APIService = async ({
    endpoint,
    method = "GET",
    data = null,
    query = null,
    includeCredentials = true,
    headers = {},
    baseUrl = process.env.REACT_APP_BASE_URL,
}) => {
    try {
        let url = `${baseUrl}${endpoint}`;

        if (query && typeof query === 'object') {
            const filteredQuery = Object.fromEntries(
                Object.entries(query).filter(([_, value]) => value !== null && value !== undefined)
            );
            const queryString = new URLSearchParams(filteredQuery).toString();
            if (queryString) {
                url += `?${queryString}`;
            }
        }
        const raw = localStorage.getItem("userData");
        const userData = raw ? JSON.parse(raw) : null;

        let finalHeaders = {
            ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
            ...headers,
        };

        // If no authorization header, add it
        if (!headers.Authorization) {
            finalHeaders.Authorization = userData ? `Bearer ${userData.token}` : "";
        }

        const response = await fetch(url, {
            method: method,
            credentials: includeCredentials ? "include" : "same-origin",
            headers: finalHeaders,
            body: method !== "GET" && data ? (data instanceof FormData ? data : JSON.stringify(data)) : null,
        }).catch((error) => {
            throw new Error("Network request failed: " + error.message);
        });
        
        const json = await response.json().catch((error) => {
            throw new Error("Failed to parse JSON response: " + error.message);
        });

        if (!response.ok) {
            return new APIResponseModel({
                status: json.status || 'error',
                message: json.message || 'Unknown error',
                code: json.code || response.status,
                data: json.data || null,
            });
        }

        return new APIResponseModel({
            status: json.status,
            message: json.message,
            code: json.code,
            data: json.data,
        });

    } catch (error) {
        return new APIResponseModel({
            status: "error",
            message: "Service Unavailable",
            code: 503,
            data: null,
        });
    }
};